<template>
  <v-app>
    <div style="height:104px;box-shadow: 0 6px 8px rgba(20,19,19,0.04);background: #FFF;">
    <v-navigation-drawer
      right
      v-model="drawer"
      app
      temporary
    >
      <v-list dense subheader class="ctk-wap-menu">
        <v-list-item v-for="(menu, index) in menus" :href="'/#' + menu.link" :key="index">
          <v-list-item-content>
            <v-list-item-title>{{ menu.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app flat absolute class="app-bar" height="104" max-width="1635">
      <v-toolbar-title class="headline" style="display: flex;align-items: center;">
        <a href="/" style="dispaly:block;height:104px;"><img :src="info.logo" style="height:104px;"/></a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div>
        <v-flex style="clear: both;">
      <v-toolbar-items>
        <template v-for="(menu, index) in menus">
          <v-btn :key="index" :href="'/#' + menu.link" class="ml-0 hidden-sm-and-down white text-none ctk-menu">{{ menu.title }}</v-btn>
        </template>
        <v-app-bar-nav-icon
          class="hidden-md-and-up"
          @click.stop="drawer = !drawer"
        >
        </v-app-bar-nav-icon>
      </v-toolbar-items>
        </v-flex>
      </div>
    </v-app-bar>
    </div>
    <v-main>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </v-main>
    <Footer/>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
    Footer: () => import('@/components/Footer')
  },
  data: () => ({
    company: [],
    menus: [
      { title: '集团简介', link: 'profile' },
      { title: '集团动态', link: 'news' },
      { title: '价值观', link: 'values' },
      { title: '发展历程', link: 'history' },
      { title: '集团子公司', link: 'subsidiary' }
    ],
    afterGetData: false,
    drawer: null
  }),
  mounted () {
    this.$store.dispatch('loadInfo')
  },
  watch: {
    '$store.getters.companyInfo': {
      handler: function (val, oldVal) {
        document.querySelector('meta[name="keywords"]').setAttribute('content', val.seo_keywords)
        document.querySelector('meta[name="description"]').setAttribute('content', val.seo_description)
        document.querySelector('link[rel*=\'icon\']').setAttribute('href', val.favicon)
        this.links = val.link
      },
      deep: true
    },
    '$route' (to, from) {
      this.title(this.$route)
    }
  },
  computed: {
    info () {
      return this.$store.getters.companyInfo
    }
  },
  methods: {
    /**
     * 路由切换设置title
     * @param to
     */
    title (to) {
      // document.title = to.meta.title + '_' + this.$store.getters.companyInfo.name
    }
  }
}
</script>
<style lang="scss">
  @import 'sass/variables.scss';
  .v-application {
    font-family: $body-font-family !important;
  }
</style>
<style lang="css">
  @import 'css/public.css';
</style>
